import axios from "../axios";

const api = {
  getScopeOneConversionFactors(params, accessToken) {
    const config = {
      params,
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/conversion-factors/scope-one`, config).then(({ data }) => data);
  },

  getScopeTwoConversionFactors(params, accessToken) {
    const config = {
      params,
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/conversion-factors/scope-two`, config).then(({ data }) => data);
  },

  getScopeThreeConversionFactors(params, accessToken) {
    const config = {
      params,
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/conversion-factors/scope-three`, config).then(({ data }) => data);
  }
};

// TODO: Wire to real backend endpoint when available
export function toggleConversionFactorEnabled({ scope, typeId, typeName, enabled }) {
  console.log(`[stub] toggleConversionFactorEnabled: scope=${scope}, typeId=${typeId}, typeName=${typeName}, enabled=${enabled}`);
  return Promise.resolve({ success: true });
}

export default api;